<script>
    // https://svelte.dev/docs#createEventDispatcher
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let group;
</script>

<button on:click="{() => dispatch('groupClicked', group)}">
    <p>{group.name}</p>
</button>
